import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Background from './components/Background';
import Hero from './components/Hero';
import FeaturedProject from './components/FeaturedProject';
import Projects from './components/Projects';
import AcademyDemo from './components/AcademyDemo';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';

function MasarTechPage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, [hash]);

  return (
    <>
      <Background />
      <Hero />
      <FeaturedProject />
      <Projects />
      <AcademyDemo />
      <About />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

export default MasarTechPage;
